import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENT_OPTIONS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetPaymentServiceOptionsResult } from '../types/getPaymentOptions.types';

export const PAYMENT_SERVICE_OPTIONS = 'PaymentServiceOptions';
export const getPaymentServiceOptions = (builder: BuilderType) =>
  builder.query<GetPaymentServiceOptionsResult, void>({
    providesTags: [PAYMENT_SERVICE_OPTIONS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PAYMENT_OPTIONS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPaymentServiceOptionsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
